import { CLASSROOM_MODULE_DISMISS_GET_STARTED } from '../actions';

const dismissGetStarted = (dispatch) =>
  dispatch({
    type: CLASSROOM_MODULE_DISMISS_GET_STARTED,
    payload: {},
  });

export default (dispatch) => () => dismissGetStarted(dispatch);
